// HP-60: which environment this page is — Prod, UAT or SIT. The address
// decides: one image serves UAT and production, so the build cannot know. An
// unknown address counts as Prod: calling production "test" is the worse
// mistake. The same file is in all four frontends.

export const ENVIRONMENTS = {
  prod: { label: 'Prod', className: 'bg-red-600 text-white' },
  uat: { label: 'UAT', className: 'bg-amber-400 text-gray-900' },
  sit: { label: 'SIT', className: 'bg-blue-600 text-white' },
}

export function environmentOf(hostname = window.location.hostname) {
  const host = (hostname || '').toLowerCase()
  if (host.startsWith('uat.')) return 'uat'
  if (host === 'localhost' || host === '127.0.0.1' || host.startsWith('dev.')) return 'sit'
  return 'prod'
}

/** Prefix the tab title once, e.g. "UAT · HubPlatform". */
export function markTitle(doc = document, env = environmentOf()) {
  const prefix = `${ENVIRONMENTS[env].label} · `
  if (!doc.title.startsWith(prefix)) doc.title = prefix + doc.title
}
